import { Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/common-ui/alert-dialog";
import { buttonVariants } from "../ui/common-ui/button";

interface DeleteConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  isDeleting?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteConfirmDialog = ({
  open,
  title,
  description,
  isDeleting = false,
  onConfirm,
  onCancel,
}: DeleteConfirmDialogProps) => (
  <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && !isDeleting && onCancel()}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
        <AlertDialogAction
          onClick={(e) => {
            e.preventDefault();
            onConfirm();
          }}
          disabled={isDeleting}
          className={buttonVariants({ variant: "destructive" })}
        >
          {isDeleting && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
          Delete
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
